import React, { useEffect, useState } from 'react';

import axios from 'axios';
import { ethers } from 'ethers';

import { useGlobalContext } from '../../AppContext';
import { Button } from '../Button';
import { ConfirmAlert } from '../ConfirmAlert';

import './AddFavoriteWallet.scss';

interface AddFavoriteWalletProps {
  onClose?: any;
}

export const AddFavoriteWallet = (props: AddFavoriteWalletProps) => {
  const { setFavorites } = useGlobalContext();
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    const handleThemeChange = () => {
      const newTheme = document.body.classList.contains('dark') ? 'light' : 'dark';
      setTheme(newTheme);
    };

    handleThemeChange();

    const observer = new MutationObserver(handleThemeChange);
    const config = { attributes: true, attributeFilter: ['class'] };
    observer.observe(document.body, config);

    return () => {
      observer.disconnect();
    };
  }, []);

  // use state
  const [newAddress, setNewAddress] = useState<string>('');
  const [newName, setNewName] = useState<string>('');
  const [validNewWallet, setValidNewWallet] = useState<boolean>(false);
  const [showAddNewWalletError, setShowAddNewWalletError] = useState<string>('');

  const addToFavoriteWallets = async (address: string, name: string): Promise<void> => {
    if (!validNewWallet || !newName) {
      alert('you should enter a valid address and name');
    } else {
      try {
        const response = await axios({
          url: `${process.env.REACT_APP_API}/wallets.php`,
          params: {
            process: 'add',
            type: 'Favorite',
            address: address,
            name: name,
          },
          headers: { 'Content-Type': 'application/json' },
          withCredentials: true,
        });

        if (response && response.data && response.data.code === 0) {
          setNewName('');
          setValidNewWallet(false);
          setShowAddNewWalletError('');
          setFavorites(false);
        } else if (response && response.data && response.data.data) {
          setShowAddNewWalletError(response.data.data);
        }
        props.onClose();
      } catch (error) {}
    }
  };

  const handleOnChangeAddNewWallet = (e: any) => {
    setNewAddress(e.target.value);

    if (e.target.value) {
      if (ethers.utils.isAddress(e.target.value)) {
        setValidNewWallet(true);
      } else {
        setValidNewWallet(false);
      }
    } else {
      setValidNewWallet(false);
    }
  };

  const handleOnChangeAddNewName = (e: any) => {
    setNewName(e.target.value);
  };

  // use effect
  useEffect(() => {
    setShowAddNewWalletError('');
  }, [newName, newAddress]);

  return (
    <div className="add-favorite-wallet">
      <div id="react-confirm-alert">
        <div className={`react-confirm-alert-overlay`}>
          <div className={`react-confirm-alert-${theme}`}>
            <ConfirmAlert title="Add New Wallet" onClose={props.onClose}>
              <div className="search-input">
                <input
                  type="text"
                  placeholder="Enter wallet address..."
                  onChange={e => handleOnChangeAddNewWallet(e)}
                />
              </div>
              <div className="search-input">
                <input
                  type="text"
                  placeholder="Enter wallet name..."
                  onChange={e => handleOnChangeAddNewName(e)}
                />
              </div>
              {showAddNewWalletError && (
                <div className="alert">
                  <img src="/icons/warning-solid.svg" />
                  {showAddNewWalletError}
                </div>
              )}
              <div className="confirm-button-container">
                <Button color="six" size="large" label="Cancel" onClick={props.onClose} />
                <Button
                  color="one"
                  size="large"
                  disabled={!validNewWallet || !newName}
                  onClick={() => {
                    addToFavoriteWallets(newAddress, newName);
                  }}
                  label="Add to Favorites"
                />
              </div>
            </ConfirmAlert>
          </div>
        </div>
      </div>
    </div>
  );
};
